import { MembershipType } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { MEMBERSHIP_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
export default {
  component: ()=>MembershipType,
  mapEntryToProps: (entry: MEMBERSHIP_MODELS.MembershipType) =>
    kontentAiDataMapping.membership_type(entry),
};
